import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dialog-header border-b border-[#e5e5e5]" }
const _hoisted_2 = { class: "dialog-body relative" }
const _hoisted_3 = { class: "flex-1 border-r border-[#e5e5e5] px-[20px] py-[20px]" }
const _hoisted_4 = { class: "info-line" }
const _hoisted_5 = {
  key: 0,
  class: "team"
}
const _hoisted_6 = {
  key: 1,
  class: "team"
}
const _hoisted_7 = { class: "left" }
const _hoisted_8 = { class: "file-list" }
const _hoisted_9 = { class: "thumb" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "file-placeholder"
}
const _hoisted_12 = { class: "type-badge" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "caption" }
const _hoisted_15 = { class: "right px-[20px] py-[20px]" }
const _hoisted_16 = { class: "field" }
const _hoisted_17 = { class: "field mt-[30px] mb-[30px]" }
const _hoisted_18 = { class: "tags" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "text text-[#8a8f99]"
}
const _hoisted_22 = { class: "field" }
const _hoisted_23 = { class: "storage" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "btn absolute bottom-[20px] right-[20px]" }
const _hoisted_27 = {
  key: 0,
  class: "w-full h-full absolute top-0 left-0 flex items-center justify-center bg-[rgba(255,255,255,0.5)]",
  style: {"backdrop-filter":"blur(2px)"}
}
const _hoisted_28 = { class: "tag-picker" }
const _hoisted_29 = { class: "tp-search" }
const _hoisted_30 = { class: "tp-list" }
const _hoisted_31 = { class: "tp-letter" }
const _hoisted_32 = { class: "tp-items" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "name" }
const _hoisted_35 = { class: "add-tag-body" }
const _hoisted_36 = { class: "footer" }
const _hoisted_37 = { class: "add-cat-body" }
const _hoisted_38 = { class: "footer" }

import { ref, computed, watch, onMounted } from 'vue'
import { ElDialog, ElButton, ElSelect, ElOption, ElIcon, ElMessage } from 'element-plus'
import { Close, Search, Delete, CaretTop } from '@element-plus/icons-vue'
import { createTag, getTagPage, getCategoryPage, createCategory } from '@/api/ResourceMasonry'
import { resourcerFileUpload } from '@/api/design/resource'
import { useUserStore } from '@/stores/user'
import { multipleChoiceStore } from "@/stores/multipleChoice"
import NewLoading from '@/components/loading/loadingComp.vue'
type UploadDialogProps = {
  visible: boolean,
  folder: {
    type: Object,
    default: () => ({})
  },
  files: File[],
  currentTeam: {
    type: Object,
    default: () => ({})
  },
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadDialog',
  props: {
    visible: { type: Boolean },
    folder: {},
    files: {},
    currentTeam: {}
  },
  emits: ['update:visible', 'confirm', 'cancel', 'addFiles', 'removeFile'],
  setup(__props: any, { emit: __emit }) {

const multipleChoice = multipleChoiceStore()
// @ts-ignore
const props = __props
const emit = __emit

const innerVisible = computed({

  get: () => props.visible,
  set: v => emit('update:visible', v)
})
watch(() => props.visible, (v) => {
  multipleChoice.clearSelected()
})
const form = ref<{ category: string | null, tags: string[] }>({ category: null, tags: [] })
const localTags = ref<string[]>([])
const localCategories = ref<string[]>([])
const tagOptions = computed(() => localTags.value.filter(t => (t as any)?.name !== '全部'))
const categoryOptions = computed(() => localCategories.value.filter(t => (t as any)?.name !== '全部'))

const localInput = ref<HTMLInputElement | null>(null)
const openAdd = () => localInput.value?.click()
const onAddChange = (e: Event) => {
  const fs = Array.from((e.target as HTMLInputElement).files || [])
  const allowedExt = ['png', 'jpg', 'jpeg', 'webp', 'gif']
  const allowedMime = ['image/png', 'image/jpeg', 'image/webp', 'image/gif']
  const ok: File[] = []
  const bad: File[] = []
  for (const f of fs) {
    const ext = (f.name.split('.').pop() || '').toLowerCase()
    const mimeOk = allowedMime.includes(f.type)
    const extOk = allowedExt.includes(ext)
    if (mimeOk || extOk) ok.push(f)
    else bad.push(f)
  }
  if (bad.length) {
    ElMessage.warning('仅支持上传 png/jpg/jpeg/webp/gif 图片')
  }
  emit('addFiles', ok)
}

const isImage = (f: File) => /^image\//.test(f.type)
const fileUrl = (f: File) => URL.createObjectURL(f)
const ext = (f: File) => {
  const n = f.name.split('.')
  return n.length > 1 ? n[n.length - 1].toUpperCase() : 'FILE'
}

const onCancel = () => { innerVisible.value = false; emit('cancel') }
const onConfirm = () => {
  emit('confirm', { category: form.value.category, tags: form.value.tags, files: props.files })
  innerVisible.value = false
}

const tagsSelect = ref()
const focusTags = () => { (tagsSelect.value as any)?.focus?.() }
const removeTag = (t: number) => {
  form.value.tags.splice(t, 1)
}

const tagPickerVisible = ref(false)
const tagSearch = ref('')
const openTagPicker = () => {
  getTagPagedata()
  tagPickerVisible.value = true
}

const dataTags = computed(() => tagOptions.value.filter(t => (t as any)?.name.length))
const filteredTags = computed(() => {
  const q = (tagSearch.value || '').toLowerCase()
  return q ? dataTags.value.filter(t => (t as any)?.name.toLowerCase().includes(q)) : dataTags.value
})
const collator = new Intl.Collator('zh-CN')
const HAN_RE = /[\u4e00-\u9fa5]/
const initialBounds: Array<{ ch: string, letter: string }> = [
  { ch: '阿', letter: 'A' }, { ch: '芭', letter: 'B' }, { ch: '擦', letter: 'C' }, { ch: '搭', letter: 'D' },
  { ch: '蛾', letter: 'E' }, { ch: '发', letter: 'F' }, { ch: '噶', letter: 'G' }, { ch: '哈', letter: 'H' },
  { ch: '机', letter: 'J' }, { ch: '喀', letter: 'K' }, { ch: '垃', letter: 'L' }, { ch: '妈', letter: 'M' },
  { ch: '拿', letter: 'N' }, { ch: '哦', letter: 'O' }, { ch: '啪', letter: 'P' }, { ch: '期', letter: 'Q' },
  { ch: '然', letter: 'R' }, { ch: '撒', letter: 'S' }, { ch: '塌', letter: 'T' }, { ch: '挖', letter: 'W' },
  { ch: '昔', letter: 'X' }, { ch: '压', letter: 'Y' }, { ch: '匝', letter: 'Z' }
]
const letterOf = (s: string) => {
  const c = (s && s[0]) || ''
  if (!c) return '#'
  const up = c.toUpperCase()
  if (up >= 'A' && up <= 'Z') return up
  if (HAN_RE.test(c)) {
    for (let i = initialBounds.length - 1; i >= 0; i--) {
      if (collator.compare(c, initialBounds[i].ch) >= 0) return initialBounds[i].letter
    }
    return 'A'
  }
  return '#'
}
const groupedTags = computed(() => {
  const groups: Record<string, string[]> = {}
  for (const t of filteredTags.value) {
    const letter = letterOf((t as any)?.name || '')
    if (!groups[letter]) groups[letter] = []
    groups[letter].push(t)
  }
  for (const k of Object.keys(groups)) {
    groups[k].sort((a, b) => (a as any)?.name.localeCompare((b as any)?.name, 'zh-CN'))
  }
  const order = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)).concat('#')
  return order.filter(l => groups[l]?.length).map(l => ({ letter: l, items: groups[l] }))
})
const toggleTag = (t: string) => {
  const i = form.value.tags.findIndex((x: any) => x.id == (t as any).id)
  if (i >= 0) form.value.tags.splice(i, 1)
  else form.value.tags.push(t)
}
const addTagVisible = ref(false)
const addTagName = ref('')
const onAddTag = () => { addTagName.value = ''; addTagVisible.value = true }
const confirmAddTag = () => {
  const n = addTagName.value
  if (!n) return
  createTag({ name: n, owner_type: ((props.currentTeam as any)?.corp_code) ? 'team' : 'user', corp_code: ((props.currentTeam as any)?.corp_code) }).then(res => {
    if (res.data.data.id) {
      getTagPagedata()
      addTagVisible.value = false
    }
  })

  // return
  // if (!localTags.value.includes(n)) localTags.value.push(n)
  // if (!form.value.tags.includes(n)) form.value.tags.push(n)
}

const addCategoryVisible = ref(false)
const addCategoryName = ref('')
const openAddCategory = () => { addCategoryName.value = ''; addCategoryVisible.value = true }
const confirmAddCategory = () => {
  const n = addCategoryName.value
  if (!n) return
  createCategory({ name: n, owner_type: ((props.currentTeam as any)?.corp_code) ? 'team' : 'user', corp_code: ((props.currentTeam as any)?.corp_code) }).then(async res => {
    if (res.data.data.id) {

      await getCategoryPagedata()
      form.value.category = res.data.data.id
      addCategoryVisible.value = false
    }
  })
  // if (!n) return
  // if (!localCategories.value.includes(n)) localCategories.value.push(n)
  // form.value.category = n
  // addCategoryVisible.value = false
}
const onRemoveFile = (i: number) => { emit('removeFile', i) }
onMounted(() => {
  getTagPagedata()
  getCategoryPagedata()
})
const getTagPagedata = async () => {
  const res = await getTagPage({ owner_type: ((props.currentTeam as any)?.corp_code) ? 'team' : 'user', corp_code: ((props.currentTeam as any)?.corp_code), page: 1, size: 100 })
  try {
    localTags.value = res.data.data.items
    console.log(localTags.value)
  } catch (error) {
    localTags.value = []
  }
  return
}
const getCategoryPagedata = async () => {
  const res = await getCategoryPage({ owner_type: ((props.currentTeam as any)?.corp_code) ? 'team' : 'user', corp_code: ((props.currentTeam as any)?.corp_code), page: 1, size: 100 })
  try {
    localCategories.value = res.data.data.items
  } catch (error) {
    localCategories.value = []
  }
  return
}
const uploading = ref(false)
const loadingtext = ref('上传中...')
const confirmUpload = async () => {
  const { tags, category } = form.value
  const tag_ids = tags.map((t: any) => t.id).join(',')
  uploading.value = true
  try {
    await uploadNext(0, tag_ids, category)
    innerVisible.value = false
    form.value.tags = []
    form.value.category = ''
    emit('confirm', { category, tags, files: props.files })
  } finally {
    uploading.value = false
  }
}
const uploadNext = async (i: number, tag_ids: string, category: any) => {
  if (!props.files || i >= props.files.length) return
  const file = props.files[i]
  await resourcerFileUpload(file, (props.folder as any)?.id, ((props.currentTeam as any)?.corp_code), tag_ids, category)
  loadingtext.value = `上传中...${i + 1}/${props.files.length}`
  await uploadNext(i + 1, tag_ids, category)
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElDialog), {
      modelValue: innerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((innerVisible).value = $event)),
      width: "1080px",
      "close-on-click-modal": false,
      style: {"padding":"0px"},
      "align-center": "",
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "title" }, "资源入库", -1)),
          _createElementVNode("div", {
            class: "close cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (innerVisible.value = false))
          }, [
            _cache[12] || (_cache[12] = _createTextVNode(" 收起 ", -1)),
            _createVNode(_unref(ElIcon), null, {
              default: _withCtx(() => [
                _createVNode(_unref(CaretTop))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (__props.currentTeam)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.currentTeam.name) + "(" + _toDisplayString(__props.files.length) + ")", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, "我的空间(" + _toDisplayString(__props.files.length) + ")", 1))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "upload-tile",
                  onClick: openAdd
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("div", { class: "plus" }, "+", -1),
                  _createElementVNode("div", { class: "text" }, "点击上传", -1)
                ]))]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.files, (f, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "file-item",
                    key: i
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      (isImage(f))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: fileUrl(f)
                          }, null, 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(ext(f)), 1)),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(ext(f)), 1),
                      _createElementVNode("span", {
                        class: "delete-overlay",
                        onClick: _withModifiers(($event: any) => (onRemoveFile(i)), ["stop"])
                      }, [
                        _createVNode(_unref(ElIcon), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Delete))
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_13)
                    ]),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(f.name), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("input", {
                ref_key: "localInput",
                ref: localInput,
                type: "file",
                multiple: "",
                style: {"display":"none"},
                onChange: onAddChange,
                accept: ".png,.jpg,.jpeg,.webp,.gif"
              }, null, 544)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", { class: "label flex items-center justify-between mb-[20px]" }, [
                _cache[15] || (_cache[15] = _createElementVNode("span", null, " 分类", -1)),
                _cache[16] || (_cache[16] = _createTextVNode()),
                _createElementVNode("span", {
                  class: "link",
                  onClick: openAddCategory
                }, "+添加分类")
              ]),
              _createVNode(_unref(ElSelect), {
                modelValue: form.value.category,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.category) = $event)),
                placeholder: "未关联分类",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryOptions.value, (it) => {
                    return (_openBlock(), _createBlock(_unref(ElOption), {
                      key: it.id,
                      label: it.name,
                      value: it.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", { class: "label flex items-center justify-between mb-[20px]" }, [
                _cache[17] || (_cache[17] = _createElementVNode("span", null, " 标签", -1)),
                _cache[18] || (_cache[18] = _createTextVNode()),
                _createElementVNode("span", {
                  class: "link",
                  onClick: openTagPicker
                }, "+关联标签")
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.tags, (it, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "tag",
                    key: index
                  }, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(it.name), 1),
                    _createElementVNode("span", {
                      class: "tag-remove",
                      onClick: _withModifiers(($event: any) => (removeTag(index)), ["stop"])
                    }, [
                      _createVNode(_unref(ElIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Close))
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_20)
                  ]))
                }), 128))
              ]),
              (form.value.tags.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 未关联标签"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "label" }, "存储位置", -1)),
              _createElementVNode("div", _hoisted_23, [
                (__props.currentTeam)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, "资源库：" + _toDisplayString(__props.currentTeam?.name || '我的空间'), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, "资源库：我的空间")),
                _createElementVNode("div", null, "文件夹：" + _toDisplayString(__props.folder.name || '根目录'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_unref(ElButton), {
                type: "primary",
                onClick: confirmUpload,
                loading: uploading.value,
                disabled: uploading.value || !props.files?.length
              }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["loading", "disabled"]),
              _createVNode(_unref(ElButton), {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (innerVisible.value = false)),
                disabled: uploading.value
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ]),
        (uploading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createVNode(NewLoading, { text: loadingtext.value }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: tagPickerVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tagPickerVisible).value = $event)),
      width: "380px",
      "close-on-click-modal": true,
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_el_input, {
              modelValue: tagSearch.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tagSearch).value = $event)),
              placeholder: "输入关键词搜索标签",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])
          ]),
          _createElementVNode("div", {
            class: "tp-add",
            onClick: onAddTag
          }, [...(_cache[22] || (_cache[22] = [
            _createElementVNode("span", { class: "plus" }, "+", -1),
            _createTextVNode(" 添加标签", -1)
          ]))]),
          _createElementVNode("div", _hoisted_30, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedTags.value, (g) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "tp-group",
                key: g.letter
              }, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(g.letter), 1),
                _createElementVNode("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.items, (it) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["tp-chip", { active: form.value.tags.some(x => x.id === it.id) }]),
                      key: it,
                      onClick: ($event: any) => (toggleTag(it))
                    }, [
                      _createElementVNode("span", _hoisted_34, _toDisplayString(it.name), 1)
                    ], 10, _hoisted_33))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: addTagVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addTagVisible).value = $event)),
      width: "360px",
      title: "新建标签",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: confirmAddTag
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (addTagVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_el_input, {
            modelValue: addTagName.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addTagName).value = $event)),
            placeholder: "请输入标签名称"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElDialog), {
      modelValue: addCategoryVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addCategoryVisible).value = $event)),
      width: "360px",
      title: "新建分类",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: confirmAddCategory
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (addCategoryVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_el_input, {
            modelValue: addCategoryName.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((addCategoryName).value = $event)),
            placeholder: "请输入分类名称"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})